var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap mt-4"},[_c('div',{staticClass:"w-full mb-12 px-4"},[_c('card-users-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }